import { mockFeatures } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">为什么选择虫虫漫画</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            四大核心优势，为你打造极致的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mockFeatures.map((feat, i) => (
            <div
              key={i}
              className="group p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}